module.exports = __webpack_public_path__ + "img/banner_02.8170c83.jpg";